export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/http-worker.d8b6db43.worker.js");
}
